import { getActivitySummary } from '../api/trainer';
import { ActivitySummaryResponse, SummaryGranularity } from '../api/types';
import { fetchRange } from './volume';

/**
 * In-memory cache of the summary per granularity for the life of the page session. Each granularity is fetched
 * once. A failed fetch is dropped so it can be retried.
 */
const cache = new Map<SummaryGranularity, Promise<ActivitySummaryResponse>>();

export function loadVolumeSummary(granularity: SummaryGranularity): Promise<ActivitySummaryResponse> {
  let entry = cache.get(granularity);
  if (!entry) {
    const { from, to } = fetchRange(granularity);
    entry = getActivitySummary({ granularity, from, to });
    cache.set(granularity, entry);
    entry.catch(() => cache.delete(granularity));
  }
  return entry;
}

/** Drops every cached summary. Used by tests. */
export function clearVolumeCache(): void {
  cache.clear();
}
